function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 80.011719 9.539062 C 82.441406 18.269531 80.28125 24.210938 73.800781 30.238281 L 71.550781 32.398438 L 81.179688 72.089844 L 72.539062 81.179688 L 51.03125 51.929688 L 43.558594 58.949219 L 46.53125 71.011719 L 41.308594 76.5 L 33.929688 62.550781 L 28.621094 68.128906 L 24.121094 63.808594 L 29.339844 58.320312 L 15.300781 51.929688 L 20.429688 46.441406 L 32.941406 48.691406 L 39.511719 40.949219 L 8.820312 20.96875 L 17.460938 11.789062 L 57.78125 19.261719 L 60.121094 16.46875 C 66.601562 8.820312 73.261719 7.738281 80.011719 9.539062 Z M 80.011719 9.539062 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.35cdf54e08246f08aa588b8190d9982e.svg";
export { ForwardRef as ReactComponent };